import { RowField } from "./PayslipsTable";
import { SearchFilter } from "../../../common/components/functional/FilterSearchField/FilterSearchField";
import { Payslips } from "./Payslips";
import { StyledTableContainer } from "../styled";

type Props = {
  filters: SearchFilter[];
};

export const SalaryPagePayslips = ({ filters }: Props) => {
  // Widths need to match widths in rowHelpers.tsx
  const rowFields: RowField[] = [
    { name: "salaryDate", width: "90px" },
    { name: "payer", width: "220px" },
    { name: "valueDate", width: "90px" },
    { name: "wageReportShort", width: "90px" },
    { name: "payslipNumber", width: "90px" },
    { name: "recipient", width: "200px" },
    { name: "ssn", width: "100px" },
    { name: "payslipPeriodStart", width: "90px" },
    { name: "payslipPeriodEnd", width: "90px" },
    { name: "fringeBenefits", width: "90px" },
    { name: "socialSecurityShort", width: "90px" },
    { name: "incomeNet", width: "90px" },
    { name: "incomeGross", width: "90px" },
    { name: "taxWithholding", width: "90px" },
    { name: "pensionInsurance", width: "90px" },
    { name: "unemploymentInsurance", width: "90px" },
    { name: "taxExempt", width: "90px" },
    {
      name: "totalPayment",
      width: "90px",
    },
    {
      name: "status",
      width: "150px",
    },
  ];

  return (
    <StyledTableContainer>
      <Payslips
        filters={filters}
        rowFields={rowFields}
        showTotals
        tableContainerSx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "auto",
          "&::-webkit-scrollbar:vertical": { display: "none" },
          "& .MuiTableContainer-root": { overflowX: "visible" },
        }}
      />
    </StyledTableContainer>
  );
};
